module.exports = __webpack_public_path__ + "img/LTE.9df8d83e.svg";